import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Product } from 'contracts/Products';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_PRODUCT_',
  }
);

export interface FetchProductState {
  data: Product | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchProductRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Product;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchProductState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchProductState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchProductState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchProductState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchProductState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchProduct = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchProductTypes = Types;
export const FetchProductActions = Creators;
